export default __webpack_public_path__ + "static/media/warning.81c013aa.svg";